import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  border: ${(props) =>
    props.strength === "Strong" ? "solid 1px #1cbff2" : "solid 1px lightgray"};
  margin-bottom: 5px;
  padding: 20px;
  cursor: pointer;
`;

const Strength = styled.div`
  font-weight: bold;
  display: inline;
  padding-right: 40px;
`;

const DateDiv = styled.div`
  display: inline;
`;

const TestDataRenderer = (props) => {
  return (
    <Wrapper {...props}>
      <Strength>{props.strength}</Strength>
      <DateDiv>{props.date}</DateDiv>
    </Wrapper>
  );
};

export default TestDataRenderer;
